"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientImpl = exports.QueryCreationCooldownResponse = exports.QueryCreationCooldownRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QueryMainAccountResponse = exports.QueryMainAccountRequest = exports.QueryMainAccountAllResponse = exports.QueryMainAccountAllRequest = exports.QuerySubAccountPowerResponse = exports.QuerySubAccountPowerRequest = exports.QueryAllPendingSubAccountResponse = exports.QueryAllPendingSubAccountRequest = exports.QueryAllSubAccountResponse = exports.QueryAllSubAccountRequest = exports.QueryGetSubAccountResponse = exports.QueryGetPendingSubAccountRequest = exports.QueryGetSubAccountRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const subaccount_1 = require("./subaccount");
const pagination_1 = require("../../../cosmos/base/query/v1beta1/pagination");
const params_1 = require("./params");
const duration_1 = require("../../../google/protobuf/duration");
exports.protobufPackage = "Switcheo.carbon.subaccount";
const baseQueryGetSubAccountRequest = { address: "", role: "" };
exports.QueryGetSubAccountRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.role !== "") {
            writer.uint32(18).string(message.role);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetSubAccountRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.role = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetSubAccountRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.role =
            object.role !== undefined && object.role !== null
                ? String(object.role)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.role !== undefined && (obj.role = message.role);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseQueryGetSubAccountRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.role = (_b = object.role) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseQueryGetPendingSubAccountRequest = {
    mainAddress: "",
    subAddress: "",
    role: "",
};
exports.QueryGetPendingSubAccountRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mainAddress !== "") {
            writer.uint32(10).string(message.mainAddress);
        }
        if (message.subAddress !== "") {
            writer.uint32(18).string(message.subAddress);
        }
        if (message.role !== "") {
            writer.uint32(26).string(message.role);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetPendingSubAccountRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.mainAddress = reader.string();
                    break;
                case 2:
                    message.subAddress = reader.string();
                    break;
                case 3:
                    message.role = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetPendingSubAccountRequest);
        message.mainAddress =
            object.mainAddress !== undefined && object.mainAddress !== null
                ? String(object.mainAddress)
                : "";
        message.subAddress =
            object.subAddress !== undefined && object.subAddress !== null
                ? String(object.subAddress)
                : "";
        message.role =
            object.role !== undefined && object.role !== null
                ? String(object.role)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.mainAddress !== undefined &&
            (obj.mainAddress = message.mainAddress);
        message.subAddress !== undefined && (obj.subAddress = message.subAddress);
        message.role !== undefined && (obj.role = message.role);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseQueryGetPendingSubAccountRequest);
        message.mainAddress = (_a = object.mainAddress) !== null && _a !== void 0 ? _a : "";
        message.subAddress = (_b = object.subAddress) !== null && _b !== void 0 ? _b : "";
        message.role = (_c = object.role) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseQueryGetSubAccountResponse = {};
exports.QueryGetSubAccountResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.subaccount !== undefined) {
            subaccount_1.SubAccount.encode(message.subaccount, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetSubAccountResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.subaccount = subaccount_1.SubAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetSubAccountResponse);
        message.subaccount =
            object.subaccount !== undefined && object.subaccount !== null
                ? subaccount_1.SubAccount.fromJSON(object.subaccount)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.subaccount !== undefined &&
            (obj.subaccount = message.subaccount
                ? subaccount_1.SubAccount.toJSON(message.subaccount)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetSubAccountResponse);
        message.subaccount =
            object.subaccount !== undefined && object.subaccount !== null
                ? subaccount_1.SubAccount.fromPartial(object.subaccount)
                : undefined;
        return message;
    },
};
const baseQueryAllSubAccountRequest = { mainAddress: "" };
exports.QueryAllSubAccountRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        if (message.mainAddress !== "") {
            writer.uint32(18).string(message.mainAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllSubAccountRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.mainAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllSubAccountRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        message.mainAddress =
            object.mainAddress !== undefined && object.mainAddress !== null
                ? String(object.mainAddress)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        message.mainAddress !== undefined &&
            (obj.mainAddress = message.mainAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllSubAccountRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        message.mainAddress = (_a = object.mainAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryAllSubAccountResponse = {};
exports.QueryAllSubAccountResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.subaccounts) {
            subaccount_1.SubAccount.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllSubAccountResponse);
        message.subaccounts = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.subaccounts.push(subaccount_1.SubAccount.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllSubAccountResponse);
        message.subaccounts = ((_a = object.subaccounts) !== null && _a !== void 0 ? _a : []).map((e) => subaccount_1.SubAccount.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.subaccounts) {
            obj.subaccounts = message.subaccounts.map((e) => e ? subaccount_1.SubAccount.toJSON(e) : undefined);
        }
        else {
            obj.subaccounts = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllSubAccountResponse);
        message.subaccounts = ((_a = object.subaccounts) !== null && _a !== void 0 ? _a : []).map((e) => subaccount_1.SubAccount.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllPendingSubAccountRequest = {
    mainAddress: "",
    role: "",
    subAddress: "",
};
exports.QueryAllPendingSubAccountRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        if (message.mainAddress !== "") {
            writer.uint32(18).string(message.mainAddress);
        }
        if (message.role !== "") {
            writer.uint32(26).string(message.role);
        }
        if (message.subAddress !== "") {
            writer.uint32(34).string(message.subAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPendingSubAccountRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.mainAddress = reader.string();
                    break;
                case 3:
                    message.role = reader.string();
                    break;
                case 4:
                    message.subAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllPendingSubAccountRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        message.mainAddress =
            object.mainAddress !== undefined && object.mainAddress !== null
                ? String(object.mainAddress)
                : "";
        message.role =
            object.role !== undefined && object.role !== null
                ? String(object.role)
                : "";
        message.subAddress =
            object.subAddress !== undefined && object.subAddress !== null
                ? String(object.subAddress)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        message.mainAddress !== undefined &&
            (obj.mainAddress = message.mainAddress);
        message.role !== undefined && (obj.role = message.role);
        message.subAddress !== undefined && (obj.subAddress = message.subAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseQueryAllPendingSubAccountRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        message.mainAddress = (_a = object.mainAddress) !== null && _a !== void 0 ? _a : "";
        message.role = (_b = object.role) !== null && _b !== void 0 ? _b : "";
        message.subAddress = (_c = object.subAddress) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseQueryAllPendingSubAccountResponse = {};
exports.QueryAllPendingSubAccountResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.subaccounts) {
            subaccount_1.SubAccount.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPendingSubAccountResponse);
        message.subaccounts = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.subaccounts.push(subaccount_1.SubAccount.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPendingSubAccountResponse);
        message.subaccounts = ((_a = object.subaccounts) !== null && _a !== void 0 ? _a : []).map((e) => subaccount_1.SubAccount.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.subaccounts) {
            obj.subaccounts = message.subaccounts.map((e) => e ? subaccount_1.SubAccount.toJSON(e) : undefined);
        }
        else {
            obj.subaccounts = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPendingSubAccountResponse);
        message.subaccounts = ((_a = object.subaccounts) !== null && _a !== void 0 ? _a : []).map((e) => subaccount_1.SubAccount.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQuerySubAccountPowerRequest = { address: "" };
exports.QuerySubAccountPowerRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQuerySubAccountPowerRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQuerySubAccountPowerRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQuerySubAccountPowerRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQuerySubAccountPowerResponse = { power: "" };
exports.QuerySubAccountPowerResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.power !== "") {
            writer.uint32(10).string(message.power);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQuerySubAccountPowerResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.power = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQuerySubAccountPowerResponse);
        message.power =
            object.power !== undefined && object.power !== null
                ? String(object.power)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.power !== undefined && (obj.power = message.power);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQuerySubAccountPowerResponse);
        message.power = (_a = object.power) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryMainAccountAllRequest = { subAddress: "" };
exports.QueryMainAccountAllRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.subAddress !== "") {
            writer.uint32(10).string(message.subAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryMainAccountAllRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.subAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryMainAccountAllRequest);
        message.subAddress =
            object.subAddress !== undefined && object.subAddress !== null
                ? String(object.subAddress)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.subAddress !== undefined && (obj.subAddress = message.subAddress);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryMainAccountAllRequest);
        message.subAddress = (_a = object.subAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryMainAccountAllResponse = {};
exports.QueryMainAccountAllResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.mainAccounts) {
            subaccount_1.MainAccount.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryMainAccountAllResponse);
        message.mainAccounts = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.mainAccounts.push(subaccount_1.MainAccount.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryMainAccountAllResponse);
        message.mainAccounts = ((_a = object.mainAccounts) !== null && _a !== void 0 ? _a : []).map((e) => subaccount_1.MainAccount.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.mainAccounts) {
            obj.mainAccounts = message.mainAccounts.map((e) => e ? subaccount_1.MainAccount.toJSON(e) : undefined);
        }
        else {
            obj.mainAccounts = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryMainAccountAllResponse);
        message.mainAccounts = ((_a = object.mainAccounts) !== null && _a !== void 0 ? _a : []).map((e) => subaccount_1.MainAccount.fromPartial(e));
        return message;
    },
};
const baseQueryMainAccountRequest = { subAddress: "", role: "" };
exports.QueryMainAccountRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.subAddress !== "") {
            writer.uint32(10).string(message.subAddress);
        }
        if (message.role !== "") {
            writer.uint32(18).string(message.role);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryMainAccountRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.subAddress = reader.string();
                    break;
                case 2:
                    message.role = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryMainAccountRequest);
        message.subAddress =
            object.subAddress !== undefined && object.subAddress !== null
                ? String(object.subAddress)
                : "";
        message.role =
            object.role !== undefined && object.role !== null
                ? String(object.role)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.subAddress !== undefined && (obj.subAddress = message.subAddress);
        message.role !== undefined && (obj.role = message.role);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseQueryMainAccountRequest);
        message.subAddress = (_a = object.subAddress) !== null && _a !== void 0 ? _a : "";
        message.role = (_b = object.role) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseQueryMainAccountResponse = {};
exports.QueryMainAccountResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mainAccount !== undefined) {
            subaccount_1.MainAccount.encode(message.mainAccount, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryMainAccountResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.mainAccount = subaccount_1.MainAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryMainAccountResponse);
        message.mainAccount =
            object.mainAccount !== undefined && object.mainAccount !== null
                ? subaccount_1.MainAccount.fromJSON(object.mainAccount)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.mainAccount !== undefined &&
            (obj.mainAccount = message.mainAccount
                ? subaccount_1.MainAccount.toJSON(message.mainAccount)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryMainAccountResponse);
        message.mainAccount =
            object.mainAccount !== undefined && object.mainAccount !== null
                ? subaccount_1.MainAccount.fromPartial(object.mainAccount)
                : undefined;
        return message;
    },
};
const baseQueryParamsRequest = {};
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
};
const baseQueryParamsResponse = {};
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            params_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = params_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.Params.fromJSON(object.params)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? params_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.Params.fromPartial(object.params)
                : undefined;
        return message;
    },
};
const baseQueryCreationCooldownRequest = { address: "", role: "" };
exports.QueryCreationCooldownRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.role !== "") {
            writer.uint32(18).string(message.role);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryCreationCooldownRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.role = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryCreationCooldownRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.role =
            object.role !== undefined && object.role !== null
                ? String(object.role)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.role !== undefined && (obj.role = message.role);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseQueryCreationCooldownRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.role = (_b = object.role) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseQueryCreationCooldownResponse = {};
exports.QueryCreationCooldownResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.cooldownDuration !== undefined) {
            duration_1.Duration.encode(message.cooldownDuration, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryCreationCooldownResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.cooldownDuration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryCreationCooldownResponse);
        message.cooldownDuration =
            object.cooldownDuration !== undefined && object.cooldownDuration !== null
                ? duration_1.Duration.fromJSON(object.cooldownDuration)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.cooldownDuration !== undefined &&
            (obj.cooldownDuration = message.cooldownDuration
                ? duration_1.Duration.toJSON(message.cooldownDuration)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryCreationCooldownResponse);
        message.cooldownDuration =
            object.cooldownDuration !== undefined && object.cooldownDuration !== null
                ? duration_1.Duration.fromPartial(object.cooldownDuration)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.SubAccount = this.SubAccount.bind(this);
        this.PendingSubAccount = this.PendingSubAccount.bind(this);
        this.SubAccountAll = this.SubAccountAll.bind(this);
        this.PendingSubAccountAll = this.PendingSubAccountAll.bind(this);
        this.SubAccountPower = this.SubAccountPower.bind(this);
        this.MainAccountAll = this.MainAccountAll.bind(this);
        this.MainAccount = this.MainAccount.bind(this);
        this.Params = this.Params.bind(this);
        this.Cooldown = this.Cooldown.bind(this);
    }
    SubAccount(request) {
        const data = exports.QueryGetSubAccountRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.subaccount.Query", "SubAccount", data);
        return promise.then((data) => exports.QueryGetSubAccountResponse.decode(new minimal_1.default.Reader(data)));
    }
    PendingSubAccount(request) {
        const data = exports.QueryGetPendingSubAccountRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.subaccount.Query", "PendingSubAccount", data);
        return promise.then((data) => exports.QueryGetSubAccountResponse.decode(new minimal_1.default.Reader(data)));
    }
    SubAccountAll(request) {
        const data = exports.QueryAllSubAccountRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.subaccount.Query", "SubAccountAll", data);
        return promise.then((data) => exports.QueryAllSubAccountResponse.decode(new minimal_1.default.Reader(data)));
    }
    PendingSubAccountAll(request) {
        const data = exports.QueryAllPendingSubAccountRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.subaccount.Query", "PendingSubAccountAll", data);
        return promise.then((data) => exports.QueryAllPendingSubAccountResponse.decode(new minimal_1.default.Reader(data)));
    }
    SubAccountPower(request) {
        const data = exports.QuerySubAccountPowerRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.subaccount.Query", "SubAccountPower", data);
        return promise.then((data) => exports.QuerySubAccountPowerResponse.decode(new minimal_1.default.Reader(data)));
    }
    MainAccountAll(request) {
        const data = exports.QueryMainAccountAllRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.subaccount.Query", "MainAccountAll", data);
        return promise.then((data) => exports.QueryMainAccountAllResponse.decode(new minimal_1.default.Reader(data)));
    }
    MainAccount(request) {
        const data = exports.QueryMainAccountRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.subaccount.Query", "MainAccount", data);
        return promise.then((data) => exports.QueryMainAccountResponse.decode(new minimal_1.default.Reader(data)));
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.subaccount.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    Cooldown(request) {
        const data = exports.QueryCreationCooldownRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.subaccount.Query", "Cooldown", data);
        return promise.then((data) => exports.QueryCreationCooldownResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
